import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend dayjs with the necessary plugins
dayjs.extend(utc);
dayjs.extend(customParseFormat);

/**
 * Converts a date string to a UTC date.
 * If the date string is in a custom format, the format should be provided.
 * If the date string is in ISO UTC format, the format should be omitted.
 * @returns null if the date is invalid otherwise the date in UTC format
 */
function convertToUTC(dateString: string, format?: string): Dayjs | null {
   let date: Dayjs;

   // date string provided is likely to be in a custom format
   // ex: ex YYYY-MM-DD HH:mm:ss, ex YYYY-MM-DD
   if (format) {
      date = dayjs(dateString, format, true).utc();
   }
   // date string provided is likely to be in ISO UTC format (ex: 2021-09-01T00:00:00Z)
   else {
      date = dayjs(dateString).utc();
   }

   // Check if the date is valid
   if (!date.isValid()) {
      console.error(`Invalid date provided: ${dateString}`);
      return null;
   }

   // Return the date in ISO UTC format
   return date;
}

export { convertToUTC };
